import React from 'react';
import MDEditor from '@uiw/react-md-editor';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css'; // Include KaTeX CSS
import ZoomImage from './ZoomImage';

type MarkDownViewProps = {
    source: string;
    color?: string;
    style?: React.CSSProperties;
    nazivKlase?: string;
    show3Rows?: boolean;
    zoomImages?: boolean;
};

export function MarkDownView({ source, color = '#19315f', nazivKlase = ' test-pitanje-dimension ', show3Rows = false, zoomImages = false, style = {} }: MarkDownViewProps) {
    return (
        <MDEditor.Markdown
            className={nazivKlase + (show3Rows ? ' markdown-tri-reda' : '')}
            source={source}
            style={{
                whiteSpace: 'pre-wrap',
                backgroundColor: 'transparent',
                color: color,
                fontWeight: 500,
                fontFamily: 'inherit',
                ...style, // dodaj dodatne stilove
            }}
            remarkPlugins={[remarkMath]}
            rehypePlugins={[rehypeKatex]}
            components={zoomImages ? { img: ({ src, alt }: any) => <ZoomImage src={src} alt={alt} /> } : undefined}
        />
    );
}
